import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import api, { getPublicFileUrl } from "@/lib/api";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { PUBLIC_BOOKING } from "@/constants/testIds";

const FALLBACK_IMAGES = [
  "https://images.pexels.com/photos/16122133/pexels-photo-16122133.jpeg",
  "https://images.pexels.com/photos/34220287/pexels-photo-34220287.jpeg",
];

export default function StepProfessionals({ clinic, service, onSelect, onBack }) {
  const { t } = usePublicLang();
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/public/clinics/${clinic.slug}/professionals`, { params: { service_id: service.id } })
      .then(({ data }) => { if (active) setProfessionals(data); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [clinic.slug, service.id]);

  return (
    <div>
      <button
        type="button"
        onClick={onBack}
        className="text-sm text-[#5C554D] underline underline-offset-4 mb-6 inline-block"
        data-testid={`${PUBLIC_BOOKING.backButtonPrefix}2`}
      >
        &larr; {t("common.back")}
      </button>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="w-6 h-6 animate-spin text-[var(--brand-primary)]" />
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid={PUBLIC_BOOKING.professionalsList}>
          <button
            type="button"
            onClick={() => onSelect({ id: "any", name: t("step2.anyName") })}
            className="flex flex-col items-center gap-2 bg-white border border-[rgba(140,125,112,0.2)] rounded-2xl p-4 hover:shadow-md hover:border-[var(--brand-primary)] transition-all active:scale-[0.98]"
            data-testid={PUBLIC_BOOKING.anyProfessionalButton}
          >
            <div className="w-16 h-16 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center">
              <Sparkles className="w-7 h-7 text-[var(--brand-primary)]" />
            </div>
            <span className="text-sm font-medium text-center leading-snug">{t("step2.anyName")}</span>
            <span className="text-xs text-[#5C554D] text-center leading-snug">{t("step2.anyDesc")}</span>
          </button>

          {professionals.map((p, idx) => (
            <button
              key={p.id}
              type="button"
              onClick={() => onSelect(p)}
              className="flex flex-col items-center gap-2 bg-white border border-[rgba(140,125,112,0.2)] rounded-2xl p-4 hover:shadow-md hover:border-[var(--brand-primary)] transition-all active:scale-[0.98]"
              data-testid={`${PUBLIC_BOOKING.professionalCardPrefix}${p.id}`}
            >
              <img
                src={p.photo_url ? getPublicFileUrl(p.photo_url) : FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length]}
                alt={p.name}
                className="w-16 h-16 rounded-full object-cover"
              />
              <span className="text-sm font-medium text-center leading-snug">{p.name}</span>
              {p.specialty && <span className="text-xs text-[#5C554D] text-center leading-snug">{p.specialty}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
